import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../global/Button';
import withModal from '../../global/modal/withModal';
import { ALBUM_SUBTYPE } from '../../../constants/albums';

export const SIBLING_DISCOUNT_ALERT_MODAL = 'modal/SIBLING_DISCOUNT_ALERT';

const propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  onAddIdentity: PropTypes.func.isRequired,
  albumSubtype: PropTypes.oneOf(Object.values(ALBUM_SUBTYPE)),
};

const SiblingDiscountAlert = ({
  onRequestClose,
  albumSubtype,
  onAddIdentity,
}) => {
  const isCamps = albumSubtype === ALBUM_SUBTYPE.CAMPS;
  const ownerLabel = isCamps ? 'camper' : 'photographer';
  const identityLabel = isCamps ? 'camper' : 'attendant';

  return (
    <div className="text-center px-3">
      <h2 className="text-extra-bold mb-1">
        Your {ownerLabel} offers a sibling discount!
      </h2>

      <p className="mb-4">
        If you have more than one {identityLabel} attending this{' '}
        {isCamps ? 'summer' : 'event'}, please be sure to add them now as
        discounts only apply when purchased together.
      </p>

      <div className="d-flex flex-column">
        <Button btnBlock btnStyle="primary" onClick={onRequestClose}>
          I only have one {identityLabel}
        </Button>

        <Button
          btnBlock
          btnStyle="secondary"
          className="mb-1"
          onClick={() => {
            onAddIdentity();
            onRequestClose();
          }}
        >
          Add another {identityLabel}
        </Button>
      </div>
    </div>
  );
};

SiblingDiscountAlert.propTypes = propTypes;

export default withModal(SiblingDiscountAlert, {
  name: SIBLING_DISCOUNT_ALERT_MODAL,
  size: 'sm',
});
